import React from "react";
import { theme } from "codeArt/components/Base";
import { DataContext } from "./context";
import { threePosition } from "codeArt/common";
import { stickType } from "app/components/common";
import { FM01, FM02, FM03, FM04, FM05, FM06, FM07, FM08, FM09, Shift1, Shift2, Shift3, Team1, Team2, Team3 } from "app/constant";

//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
  DataContext.register([
    {
      name: "REPORT_PRODUCTION_OUTPUT_SLIM",
      data: REPORT_PRODUCTION_OUTPUT_SLIM
    },
    {
      name: "REPORT_PRODUCTION_OUTPUT",
      data: REPORT_PRODUCTION_OUTPUT
    },
    {
      name: "REPORT_PRODUCTION_QUALIFIEDRANK_BAR",
      data: REPORT_PRODUCTION_QUALIFIEDRANK_BAR
    },
    {
      name: "REPORT_PRODUCTION_QUALIFIEDRANK_BAR_SLIM",
      data: REPORT_PRODUCTION_QUALIFIEDRANK_BAR_SLIM
    },
    {
      name: "REPORT_PRODUCTION_STICKTYPE",
      data: REPORT_PRODUCTION_STICKTYPE
    },
    {
      name: "REPORT_SCRAP_AMOUNT_SLIM",
      data: REPORT_SCRAP_AMOUNT_SLIM
    },
    {
      name: "REPORT_SCRAP_AMOUNT",
      data: REPORT_SCRAP_AMOUNT
    },
    {
      name: "REPORT_PRODUCTION_SPEED_SLIM",
      data: REPORT_PRODUCTION_SPEED_SLIM
    },
    {
      name: "REPORT_PRODUCTION_OEE_SLIM",
      data: REPORT_PRODUCTION_OEE_SLIM
    },
    {
      name: "REPORT_PRODUCTION_AVAILABILITY_SLIM",
      data: REPORT_PRODUCTION_AVAILABILITY_SLIM
    },
    {
      name: "REPORT_PRODUCTION_AVERAGETIME_SLIM",
      data: REPORT_PRODUCTION_AVERAGETIME_SLIM
    },
    {
      name: "REPORT_PRODUCTION_EFFECT_SLIM",
      data: REPORT_PRODUCTION_EFFECT_SLIM
    },
    {
      name: "REPORT_PRODUCTION_STICK_OUTPUT",
      data: REPORT_PRODUCTION_STICK_OUTPUT
    },
    {
      name: "REPORT_PRODUCTION_STICKTYPE_RANK",
      data: REPORT_PRODUCTION_STICKTYPE_RANK
    },
    {
      name: "REPORT_PRODUCTION_STICKTYPE_QUALIFIEDRANK",
      data: REPORT_PRODUCTION_STICKTYPE_QUALIFIEDRANK
    },
    {
      name: "REPORT_PRODUCTION_STICKTYPE_TREND",
      data: REPORT_PRODUCTION_STICKTYPE_TREND
    },
    {
      name: "REPORT_PRODUCTION_STICKTYPE_QUALIFIEDTREND",
      data: REPORT_PRODUCTION_STICKTYPE_QUALIFIEDTREND
    },
    {
      name: "REPORT_PRODUCTION_SHIFT_RANK",
      data: REPORT_PRODUCTION_SHIFT_RANK
    },
    {
      name: "REPORT_PRODUCTION_SHIFT_QUALIFIEDRANK",
      data: REPORT_PRODUCTION_SHIFT_QUALIFIEDRANK
    },
    {
      name: "REPORT_PRODUCTION_SHIFT_TYPE",
      data: REPORT_PRODUCTION_SHIFT_TYPE
    },
    {
      name: "REPORT_PRODUCTION_SHIFT_TREND",
      data: REPORT_PRODUCTION_SHIFT_TREND
    },
    {
      name: "REPORT_PRODUCTION_SHIFT_QUALIFIEDTREND",
      data: REPORT_PRODUCTION_SHIFT_QUALIFIEDTREND
    },
    {
      name: "REPORT_PRODUCTION_SHIFT_TYPE_TREND",
      data: REPORT_PRODUCTION_SHIFT_TYPE_TREND
    }
    ,
    {
      name: "REPORT_PRODUCTION_DEVICE_ANALYZE_RANK",
      data: REPORT_PRODUCTION_DEVICE_ANALYZE_RANK
    }
    ,
    {
      name: "REPORT_PRODUCTION_DEVICE_ANALYZE_TREND",
      data: REPORT_PRODUCTION_DEVICE_ANALYZE_TREND
    }
    ,
    {
      name: "REPORT_PRODUCTION_DEVICE_ANALYZE_QUALIFIEDRANK",
      data: REPORT_PRODUCTION_DEVICE_ANALYZE_QUALIFIEDRANK
    }
    ,
    {
      name: "REPORT_PRODUCTION_DEVICE_ANALYZE_QUALIFIEDTREND",
      data: REPORT_PRODUCTION_DEVICE_ANALYZE_QUALIFIEDTREND
    }
  ]);
}

const REPORT_PRODUCTION_EFFECT_SLIM = [[0.75, 0.825, 0.84, 0.79, 0.76]];

const REPORT_PRODUCTION_AVAILABILITY_SLIM = [[0.82, 0.84, 0.92, 0.85, 0.86]];

const REPORT_PRODUCTION_OEE_SLIM = [[0.83, 0.86, 0.92, 0.85, 0.81]];

const REPORT_PRODUCTION_DEVICE_ANALYZE_QUALIFIEDTREND = [
  [
    {
      type: "三月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 152123, ...Shift1 },
              { type: "中班", value: 131654, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 121451, ...Shift1 },
              { type: "中班", value: 145221, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 122650, ...Shift1 },
              { type: "中班", value: 141554, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 143542, ...Shift1 },
              { type: "中班", value: 153641, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 155421, ...Shift1 },
              { type: "中班", value: 144451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 141465, ...Shift1 },
              { type: "中班", value: 121465, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 161445, ...Shift1 },
              { type: "中班", value: 131987, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 141656, ...Shift1 },
              { type: "中班", value: 171478, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 132448, ...Shift1 },
              { type: "中班", value: 161456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 141454, ...Shift1 },
              { type: "中班", value: 131456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 181454, ...Shift1 },
              { type: "中班", value: 181566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 161656, ...Shift1 },
              { type: "中班", value: 151456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 191456, ...Shift1 },
              { type: "中班", value: 181456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 211566, ...Shift1 },
              { type: "中班", value: 191566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 191656, ...Shift1 },
              { type: "中班", value: 161565, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 171465, ...Shift1 },
              { type: "中班", value: 161656, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 150655, ...Shift1 },
              { type: "中班", value: 170564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 150566, ...Shift1 },
              { type: "中班", value: 190466, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 181666, ...Shift1 },
              { type: "中班", value: 192455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 171455, ...Shift1 },
              { type: "中班", value: 162465, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 171656, ...Shift1 },
              { type: "中班", value: 153566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 161667, ...Shift1 },
              { type: "中班", value: 181665, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 141665, ...Shift1 },
              { type: "中班", value: 162646, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 153246, ...Shift1 },
              { type: "中班", value: 171664, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 191656, ...Shift1 },
              { type: "中班", value: 191464, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 161799, ...Shift1 },
              { type: "中班", value: 172995, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 192464, ...Shift1 },
              { type: "中班", value: 161666, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    },
    {
      type: "四月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 151113, ...Shift1 },
              { type: "中班", value: 142624, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 162451, ...Shift1 },
              { type: "中班", value: 120221, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 142650, ...Shift1 },
              { type: "中班", value: 143554, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 151542, ...Shift1 },
              { type: "中班", value: 162641, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 123421, ...Shift1 },
              { type: "中班", value: 151451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 161465, ...Shift1 },
              { type: "中班", value: 171461, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 142445, ...Shift1 },
              { type: "中班", value: 121987, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 121656, ...Shift1 },
              { type: "中班", value: 112478, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 151448, ...Shift1 },
              { type: "中班", value: 121456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 141454, ...Shift1 },
              { type: "中班", value: 162456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 114454, ...Shift1 },
              { type: "中班", value: 124566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 123656, ...Shift1 },
              { type: "中班", value: 121456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 182456, ...Shift1 },
              { type: "中班", value: 151456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 174566, ...Shift1 },
              { type: "中班", value: 121456, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 152656, ...Shift1 },
              { type: "中班", value: 161565, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 181465, ...Shift1 },
              { type: "中班", value: 192656, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 174655, ...Shift1 },
              { type: "中班", value: 175564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 141566, ...Shift1 },
              { type: "中班", value: 192466, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 172666, ...Shift1 },
              { type: "中班", value: 211455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 161455, ...Shift1 },
              { type: "中班", value: 132465, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 172656, ...Shift1 },
              { type: "中班", value: 171566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 161667, ...Shift1 },
              { type: "中班", value: 152325, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 143665, ...Shift1 },
              { type: "中班", value: 162216, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 151246, ...Shift1 },
              { type: "中班", value: 131164, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 161456, ...Shift1 },
              { type: "中班", value: 201324, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 211399, ...Shift1 },
              { type: "中班", value: 152295, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 212432, ...Shift1 },
              { type: "中班", value: 212326, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    },
    {
      type: "五月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 150243, ...Shift1 },
              { type: "中班", value: 132334, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 143211, ...Shift1 },
              { type: "中班", value: 156321, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 174120, ...Shift1 },
              { type: "中班", value: 173254, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164423, ...Shift1 },
              { type: "中班", value: 155121, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 155421, ...Shift1 },
              { type: "中班", value: 134451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 121465, ...Shift1 },
              { type: "中班", value: 131465, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 121445, ...Shift1 },
              { type: "中班", value: 151987, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 121656, ...Shift1 },
              { type: "中班", value: 131278, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 121218, ...Shift1 },
              { type: "中班", value: 121326, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 121324, ...Shift1 },
              { type: "中班", value: 141436, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 114324, ...Shift1 },
              { type: "中班", value: 114366, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 121356, ...Shift1 },
              { type: "中班", value: 131456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 191456, ...Shift1 },
              { type: "中班", value: 192326, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 211566, ...Shift1 },
              { type: "中班", value: 191566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 191656, ...Shift1 },
              { type: "中班", value: 182325, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 181213, ...Shift1 },
              { type: "中班", value: 152124, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 161123, ...Shift1 },
              { type: "中班", value: 173156, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 152213, ...Shift1 },
              { type: "中班", value: 181214, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 181666, ...Shift1 },
              { type: "中班", value: 192455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 172455, ...Shift1 },
              { type: "中班", value: 163465, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 171656, ...Shift1 },
              { type: "中班", value: 152566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 162667, ...Shift1 },
              { type: "中班", value: 181665, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 142665, ...Shift1 },
              { type: "中班", value: 161646, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 151246, ...Shift1 },
              { type: "中班", value: 172664, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 212656, ...Shift1 },
              { type: "中班", value: 193464, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 162799, ...Shift1 },
              { type: "中班", value: 211995, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 152657, ...Shift1 },
              { type: "中班", value: 211675, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    },
    {
      type: "六月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 142123, ...Shift1 },
              { type: "中班", value: 185344, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 114451, ...Shift1 },
              { type: "中班", value: 131321, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 161250, ...Shift1 },
              { type: "中班", value: 181214, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164542, ...Shift1 },
              { type: "中班", value: 151641, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 195421, ...Shift1 },
              { type: "中班", value: 161451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 131135, ...Shift1 },
              { type: "中班", value: 163125, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 141241, ...Shift1 },
              { type: "中班", value: 134327, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 121653, ...Shift1 },
              { type: "中班", value: 135218, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 122448, ...Shift1 },
              { type: "中班", value: 173216, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 154454, ...Shift1 },
              { type: "中班", value: 163156, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 144454, ...Shift1 },
              { type: "中班", value: 113126, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164656, ...Shift1 },
              { type: "中班", value: 124456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 187456, ...Shift1 },
              { type: "中班", value: 184312, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 214566, ...Shift1 },
              { type: "中班", value: 161566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 191656, ...Shift1 },
              { type: "中班", value: 121565, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 171465, ...Shift1 },
              { type: "中班", value: 171656, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 152655, ...Shift1 },
              { type: "中班", value: 172564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 152566, ...Shift1 },
              { type: "中班", value: 212466, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 151666, ...Shift1 },
              { type: "中班", value: 131455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 171455, ...Shift1 },
              { type: "中班", value: 142465, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 172656, ...Shift1 },
              { type: "中班", value: 151566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 161667, ...Shift1 },
              { type: "中班", value: 181665, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 142665, ...Shift1 },
              { type: "中班", value: 162646, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 162246, ...Shift1 },
              { type: "中班", value: 172664, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 162656, ...Shift1 },
              { type: "中班", value: 212464, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 172321, ...Shift1 },
              { type: "中班", value: 183995, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 163464, ...Shift1 },
              { type: "中班", value: 251666, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    },
    {
      type: "七月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 121123, ...Shift1 },
              { type: "中班", value: 121654, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 122451, ...Shift1 },
              { type: "中班", value: 120221, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 162650, ...Shift1 },
              { type: "中班", value: 131554, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 142214, ...Shift1 },
              { type: "中班", value: 143641, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 121121, ...Shift1 },
              { type: "中班", value: 163451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 144465, ...Shift1 },
              { type: "中班", value: 113114, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 123445, ...Shift1 },
              { type: "中班", value: 125187, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 154656, ...Shift1 },
              { type: "中班", value: 145478, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 141448, ...Shift1 },
              { type: "中班", value: 162456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 163454, ...Shift1 },
              { type: "中班", value: 162456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 191454, ...Shift1 },
              { type: "中班", value: 182566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164656, ...Shift1 },
              { type: "中班", value: 151456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 121456, ...Shift1 },
              { type: "中班", value: 152456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 194566, ...Shift1 },
              { type: "中班", value: 174566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 142656, ...Shift1 },
              { type: "中班", value: 131565, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 192465, ...Shift1 },
              { type: "中班", value: 151656, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 182655, ...Shift1 },
              { type: "中班", value: 171564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 161566, ...Shift1 },
              { type: "中班", value: 192466, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 152666, ...Shift1 },
              { type: "中班", value: 151455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 171215, ...Shift1 },
              { type: "中班", value: 141215, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 121656, ...Shift1 },
              { type: "中班", value: 162566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 134667, ...Shift1 },
              { type: "中班", value: 191665, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 133665, ...Shift1 },
              { type: "中班", value: 173646, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 131246, ...Shift1 },
              { type: "中班", value: 161664, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 191656, ...Shift1 },
              { type: "中班", value: 191464, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 191799, ...Shift1 },
              { type: "中班", value: 191995, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 191464, ...Shift1 },
              { type: "中班", value: 181666, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    }
  ]
]

const REPORT_PRODUCTION_DEVICE_ANALYZE_TREND = [
  [
    {
      type: "三月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 154123, ...Shift1 },
              { type: "中班", value: 134654, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 124451, ...Shift1 },
              { type: "中班", value: 151221, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 124650, ...Shift1 },
              { type: "中班", value: 144554, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 144542, ...Shift1 },
              { type: "中班", value: 155641, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 155421, ...Shift1 },
              { type: "中班", value: 154451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 145465, ...Shift1 },
              { type: "中班", value: 134465, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 165445, ...Shift1 },
              { type: "中班", value: 135987, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 144656, ...Shift1 },
              { type: "中班", value: 175478, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 142448, ...Shift1 },
              { type: "中班", value: 164456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 144454, ...Shift1 },
              { type: "中班", value: 134456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 184454, ...Shift1 },
              { type: "中班", value: 184566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164656, ...Shift1 },
              { type: "中班", value: 154456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 197456, ...Shift1 },
              { type: "中班", value: 184456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 214566, ...Shift1 },
              { type: "中班", value: 194566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 194656, ...Shift1 },
              { type: "中班", value: 164565, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 174465, ...Shift1 },
              { type: "中班", value: 164656, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 154655, ...Shift1 },
              { type: "中班", value: 175564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 154566, ...Shift1 },
              { type: "中班", value: 198466, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 184666, ...Shift1 },
              { type: "中班", value: 194455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 174455, ...Shift1 },
              { type: "中班", value: 166465, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 174656, ...Shift1 },
              { type: "中班", value: 154566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164667, ...Shift1 },
              { type: "中班", value: 184665, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 146665, ...Shift1 },
              { type: "中班", value: 164646, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 154246, ...Shift1 },
              { type: "中班", value: 174664, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 194656, ...Shift1 },
              { type: "中班", value: 194464, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 164799, ...Shift1 },
              { type: "中班", value: 177995, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 194464, ...Shift1 },
              { type: "中班", value: 164666, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    },
    {
      type: "四月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 154113, ...Shift1 },
              { type: "中班", value: 144624, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 164451, ...Shift1 },
              { type: "中班", value: 121221, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 144650, ...Shift1 },
              { type: "中班", value: 144554, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 154542, ...Shift1 },
              { type: "中班", value: 165641, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 125421, ...Shift1 },
              { type: "中班", value: 154451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 165465, ...Shift1 },
              { type: "中班", value: 174461, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 145445, ...Shift1 },
              { type: "中班", value: 125987, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 124656, ...Shift1 },
              { type: "中班", value: 115478, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 152448, ...Shift1 },
              { type: "中班", value: 124456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 144454, ...Shift1 },
              { type: "中班", value: 164456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 124454, ...Shift1 },
              { type: "中班", value: 134566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 124656, ...Shift1 },
              { type: "中班", value: 124456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 187456, ...Shift1 },
              { type: "中班", value: 164456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 184566, ...Shift1 },
              { type: "中班", value: 144566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 154656, ...Shift1 },
              { type: "中班", value: 164565, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 184465, ...Shift1 },
              { type: "中班", value: 194656, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 184655, ...Shift1 },
              { type: "中班", value: 175564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 144566, ...Shift1 },
              { type: "中班", value: 198466, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 174666, ...Shift1 },
              { type: "中班", value: 214455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 164455, ...Shift1 },
              { type: "中班", value: 136465, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 174656, ...Shift1 },
              { type: "中班", value: 174566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164667, ...Shift1 },
              { type: "中班", value: 154325, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 146665, ...Shift1 },
              { type: "中班", value: 163216, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 154246, ...Shift1 },
              { type: "中班", value: 132164, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 163456, ...Shift1 },
              { type: "中班", value: 214324, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 214399, ...Shift1 },
              { type: "中班", value: 154295, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 214432, ...Shift1 },
              { type: "中班", value: 214326, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    },
    {
      type: "五月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 151243, ...Shift1 },
              { type: "中班", value: 133334, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 143211, ...Shift1 },
              { type: "中班", value: 166321, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 174120, ...Shift1 },
              { type: "中班", value: 183254, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164423, ...Shift1 },
              { type: "中班", value: 175121, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 155421, ...Shift1 },
              { type: "中班", value: 144451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 125465, ...Shift1 },
              { type: "中班", value: 134465, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 125445, ...Shift1 },
              { type: "中班", value: 155987, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 124656, ...Shift1 },
              { type: "中班", value: 135278, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 123218, ...Shift1 },
              { type: "中班", value: 124326, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 124324, ...Shift1 },
              { type: "中班", value: 144436, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 124324, ...Shift1 },
              { type: "中班", value: 124366, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 124356, ...Shift1 },
              { type: "中班", value: 134456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 197456, ...Shift1 },
              { type: "中班", value: 194326, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 214566, ...Shift1 },
              { type: "中班", value: 194566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 194656, ...Shift1 },
              { type: "中班", value: 184325, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 183213, ...Shift1 },
              { type: "中班", value: 153124, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 163123, ...Shift1 },
              { type: "中班", value: 175564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 153213, ...Shift1 },
              { type: "中班", value: 183214, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 184666, ...Shift1 },
              { type: "中班", value: 194455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 174455, ...Shift1 },
              { type: "中班", value: 166465, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 174656, ...Shift1 },
              { type: "中班", value: 154566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164667, ...Shift1 },
              { type: "中班", value: 184665, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 146665, ...Shift1 },
              { type: "中班", value: 164646, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 154246, ...Shift1 },
              { type: "中班", value: 174664, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 214656, ...Shift1 },
              { type: "中班", value: 194464, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 164799, ...Shift1 },
              { type: "中班", value: 217995, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 157657, ...Shift1 },
              { type: "中班", value: 214675, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    },
    {
      type: "六月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 143123, ...Shift1 },
              { type: "中班", value: 185344, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 124451, ...Shift1 },
              { type: "中班", value: 131321, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 163250, ...Shift1 },
              { type: "中班", value: 183214, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164542, ...Shift1 },
              { type: "中班", value: 155641, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 195421, ...Shift1 },
              { type: "中班", value: 164451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 132135, ...Shift1 },
              { type: "中班", value: 163125, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 143241, ...Shift1 },
              { type: "中班", value: 134327, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 124653, ...Shift1 },
              { type: "中班", value: 135218, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 142448, ...Shift1 },
              { type: "中班", value: 173216, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164454, ...Shift1 },
              { type: "中班", value: 163156, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 144454, ...Shift1 },
              { type: "中班", value: 123126, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164656, ...Shift1 },
              { type: "中班", value: 134456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 197456, ...Shift1 },
              { type: "中班", value: 184312, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 214566, ...Shift1 },
              { type: "中班", value: 164566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 194656, ...Shift1 },
              { type: "中班", value: 124565, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 174465, ...Shift1 },
              { type: "中班", value: 174656, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 154655, ...Shift1 },
              { type: "中班", value: 175564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 154566, ...Shift1 },
              { type: "中班", value: 218466, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 154666, ...Shift1 },
              { type: "中班", value: 134455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 174455, ...Shift1 },
              { type: "中班", value: 146465, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 174656, ...Shift1 },
              { type: "中班", value: 154566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164667, ...Shift1 },
              { type: "中班", value: 184665, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 146665, ...Shift1 },
              { type: "中班", value: 164646, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164246, ...Shift1 },
              { type: "中班", value: 174664, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164656, ...Shift1 },
              { type: "中班", value: 214464, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 174321, ...Shift1 },
              { type: "中班", value: 187995, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164464, ...Shift1 },
              { type: "中班", value: 254666, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    },
    {
      type: "七月", data: [{
        color: theme.color.blue, ...FM01, type: "L01 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 124123, ...Shift1 },
              { type: "中班", value: 124654, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 124451, ...Shift1 },
              { type: "中班", value: 121221, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164650, ...Shift1 },
              { type: "中班", value: 134554, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.cyan, ...FM02, type: "L02 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 143214, ...Shift1 },
              { type: "中班", value: 145641, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 122121, ...Shift1 },
              { type: "中班", value: 164451, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 145465, ...Shift1 },
              { type: "中班", value: 114465, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.danger, ...FM03, type: "L03 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 125445, ...Shift1 },
              { type: "中班", value: 125987, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 154656, ...Shift1 },
              { type: "中班", value: 145478, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 142448, ...Shift1 },
              { type: "中班", value: 164456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.purple, ...FM04, type: "L04 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 164454, ...Shift1 },
              { type: "中班", value: 164456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 194454, ...Shift1 },
              { type: "中班", value: 184566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164656, ...Shift1 },
              { type: "中班", value: 154456, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.secondary, ...FM05, type: "L05 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 127456, ...Shift1 },
              { type: "中班", value: 154456, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 194566, ...Shift1 },
              { type: "中班", value: 174566, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 144656, ...Shift1 },
              { type: "中班", value: 134565, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.pink, ...FM06, type: "L06 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 194465, ...Shift1 },
              { type: "中班", value: 154656, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 184655, ...Shift1 },
              { type: "中班", value: 175564, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 164566, ...Shift1 },
              { type: "中班", value: 198466, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.info, ...FM07, type: "L07 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 154666, ...Shift1 },
              { type: "中班", value: 154455, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 173215, ...Shift1 },
              { type: "中班", value: 143215, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 124656, ...Shift1 },
              { type: "中班", value: 164566, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 144667, ...Shift1 },
              { type: "中班", value: 194665, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 136665, ...Shift1 },
              { type: "中班", value: 174646, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 134246, ...Shift1 },
              { type: "中班", value: 164664, ...Shift2 }
            ], ...Team3
          }
        ]
      },
      {
        color: theme.color.orange, ...FM09, type: "L09 成型机",
        data: [
          {
            type: "甲班", data: [
              { type: "早班", value: 194656, ...Shift1 },
              { type: "中班", value: 194464, ...Shift2 }
            ], ...Team1
          },
          {
            type: "乙班", data: [
              { type: "早班", value: 194799, ...Shift1 },
              { type: "中班", value: 197995, ...Shift2 }
            ], ...Team2
          },
          {
            type: "丙班", data: [
              { type: "早班", value: 194464, ...Shift1 },
              { type: "中班", value: 184666, ...Shift2 }
            ], ...Team3
          }
        ]
      }
      ]
    }
  ]
]

const REPORT_PRODUCTION_DEVICE_ANALYZE_RANK = [
  [
    {
      color: theme.color.blue, ...FM01, type: "L01 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 154123, ...Shift1 },
            { type: "中班", value: 184654, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 164451, ...Shift1 },
            { type: "中班", value: 171221, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 154650, ...Shift1 },
            { type: "中班", value: 164554, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.cyan, ...FM02, type: "L02 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 184542, ...Shift1 },
            { type: "中班", value: 155641, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 195421, ...Shift1 },
            { type: "中班", value: 164451, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 175465, ...Shift1 },
            { type: "中班", value: 164465, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.danger, ...FM03, type: "L03 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 185445, ...Shift1 },
            { type: "中班", value: 135987, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 144656, ...Shift1 },
            { type: "中班", value: 175478, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 142448, ...Shift1 },
            { type: "中班", value: 164456, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.purple, ...FM04, type: "L04 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 164454, ...Shift1 },
            { type: "中班", value: 164456, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 194454, ...Shift1 },
            { type: "中班", value: 184566, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 164656, ...Shift1 },
            { type: "中班", value: 154456, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.secondary, ...FM05, type: "L05 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 197456, ...Shift1 },
            { type: "中班", value: 184456, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 214566, ...Shift1 },
            { type: "中班", value: 194566, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 194656, ...Shift1 },
            { type: "中班", value: 164565, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.pink, ...FM06, type: "L06 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 174465, ...Shift1 },
            { type: "中班", value: 164656, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 154655, ...Shift1 },
            { type: "中班", value: 175564, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 154566, ...Shift1 },
            { type: "中班", value: 198466, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.info, ...FM07, type: "L07 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 184666, ...Shift1 },
            { type: "中班", value: 194455, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 174455, ...Shift1 },
            { type: "中班", value: 166465, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 174656, ...Shift1 },
            { type: "中班", value: 154566, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 164667, ...Shift1 },
            { type: "中班", value: 184665, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 146665, ...Shift1 },
            { type: "中班", value: 164646, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 154246, ...Shift1 },
            { type: "中班", value: 174664, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.orange, ...FM09, type: "L09 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 164656, ...Shift1 },
            { type: "中班", value: 194464, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 164799, ...Shift1 },
            { type: "中班", value: 177995, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 154464, ...Shift1 },
            { type: "中班", value: 164666, ...Shift2 }
          ], ...Team3
        }
      ]
    },

  ]
]

const REPORT_PRODUCTION_DEVICE_ANALYZE_QUALIFIEDRANK = [
  [
    {
      color: theme.color.blue, ...FM01, type: "L01 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 154123, ...Shift1 },
            { type: "中班", value: 174654, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 154451, ...Shift1 },
            { type: "中班", value: 161221, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 144650, ...Shift1 },
            { type: "中班", value: 154554, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.cyan, ...FM02, type: "L02 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 174542, ...Shift1 },
            { type: "中班", value: 165641, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 185421, ...Shift1 },
            { type: "中班", value: 154451, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 165465, ...Shift1 },
            { type: "中班", value: 154465, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.danger, ...FM03, type: "L03 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 155445, ...Shift1 },
            { type: "中班", value: 125987, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 134656, ...Shift1 },
            { type: "中班", value: 165478, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 132448, ...Shift1 },
            { type: "中班", value: 154456, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.purple, ...FM04, type: "L04 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 154454, ...Shift1 },
            { type: "中班", value: 134456, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 184454, ...Shift1 },
            { type: "中班", value: 174566, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 154656, ...Shift1 },
            { type: "中班", value: 144456, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.secondary, ...FM05, type: "L05 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 187456, ...Shift1 },
            { type: "中班", value: 174456, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 204566, ...Shift1 },
            { type: "中班", value: 194566, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 184656, ...Shift1 },
            { type: "中班", value: 154565, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.pink, ...FM06, type: "L06 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 164465, ...Shift1 },
            { type: "中班", value: 144656, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 144655, ...Shift1 },
            { type: "中班", value: 145564, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 144566, ...Shift1 },
            { type: "中班", value: 188466, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.info, ...FM07, type: "L07 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 174666, ...Shift1 },
            { type: "中班", value: 154455, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 164455, ...Shift1 },
            { type: "中班", value: 156465, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 164656, ...Shift1 },
            { type: "中班", value: 144566, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color["m-brand"], ...FM08, type: "L08 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 154667, ...Shift1 },
            { type: "中班", value: 174665, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 136665, ...Shift1 },
            { type: "中班", value: 154646, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 144246, ...Shift1 },
            { type: "中班", value: 164664, ...Shift2 }
          ], ...Team3
        }
      ]
    },
    {
      color: theme.color.orange, ...FM09, type: "L09 成型机",
      data: [
        {
          type: "甲班", data: [
            { type: "早班", value: 154656, ...Shift1 },
            { type: "中班", value: 164464, ...Shift2 }
          ], ...Team1
        },
        {
          type: "乙班", data: [
            { type: "早班", value: 154799, ...Shift1 },
            { type: "中班", value: 167995, ...Shift2 }
          ], ...Team2
        },
        {
          type: "丙班", data: [
            { type: "早班", value: 144464, ...Shift1 },
            { type: "中班", value: 154666, ...Shift2 }
          ], ...Team3
        }
      ]
    },

  ]
]

const REPORT_PRODUCTION_AVERAGETIME_SLIM = [
  [
    {
      type: "4月",
      value: 4.6,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "小时" };
      }
    },
    {
      type: "5月",
      value: 5.7,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "小时" };
      }
    },
    {
      type: "6月",
      value: 5.2,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "小时" };
      }
    },
    {
      type: "7月",
      value: 6.2,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "小时" };
      }
    }
  ]
];

const REPORT_PRODUCTION_SHIFT_TREND = [
  [
    {
      type: "四元复合棒",
      color: theme.color.secondary,
      ...stickType.quaternary,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 32624 },
            { type: "四月", value: 36721 },
            { type: "五月", value: 34324 },
            { type: "六月", value: 37345 },
            { type: "七月", value: 41245 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 35722 },
            { type: "四月", value: 48323 },
            { type: "五月", value: 47592 },
            { type: "六月", value: 51241 },
            { type: "七月", value: 58344 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 44591 },
            { type: "四月", value: 39721 },
            { type: "五月", value: 43324 },
            { type: "六月", value: 46345 },
            { type: "七月", value: 49235 }
          ]
        }
      ]
    },
    {
      type: "三元复合棒",
      color: theme.color.cyan,
      ...stickType.ternary,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 42392 },
            { type: "四月", value: 35721 },
            { type: "五月", value: 45324 },
            { type: "六月", value: 51345 },
            { type: "七月", value: 43245 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 42592 },
            { type: "四月", value: 41721 },
            { type: "五月", value: 56324 },
            { type: "六月", value: 63345 },
            { type: "七月", value: 47245 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 46592 },
            { type: "四月", value: 34721 },
            { type: "五月", value: 45324 },
            { type: "六月", value: 57345 },
            { type: "七月", value: 48245 }
          ]
        }
      ]
    },
    {
      type: "二元复合棒",
      color: theme.color.teal,
      ...stickType.duality,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 162368 },
            { type: "四月", value: 133361 },
            { type: "五月", value: 149324 },
            { type: "六月", value: 125452 },
            { type: "七月", value: 116451 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 142368 },
            { type: "四月", value: 152361 },
            { type: "五月", value: 184324 },
            { type: "六月", value: 152452 },
            { type: "七月", value: 162451 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 152361 },
            { type: "四月", value: 132362 },
            { type: "五月", value: 164323 },
            { type: "六月", value: 122454 },
            { type: "七月", value: 172457 }
          ]
        }
      ]
    },
    {
      type: "中空拉丝棒",
      color: theme.color["r-orange"],
      ...stickType.hollow,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 233556 },
            { type: "四月", value: 263545 },
            { type: "五月", value: 243452 },
            { type: "六月", value: 223524 },
            { type: "七月", value: 244552 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 214552 },
            { type: "四月", value: 251546 },
            { type: "五月", value: 242451 },
            { type: "六月", value: 262526 },
            { type: "七月", value: 253551 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 245552 },
            { type: "四月", value: 223546 },
            { type: "五月", value: 213451 },
            { type: "六月", value: 244526 },
            { type: "七月", value: 222551 }
          ]
        }
      ]
    },
    {
      type: "高透棒",
      color: theme.color.purple,
      ...stickType.through,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 314412 },
            { type: "四月", value: 324325 },
            { type: "五月", value: 332351 },
            { type: "六月", value: 352345 },
            { type: "七月", value: 342356 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 344412 },
            { type: "四月", value: 324325 },
            { type: "五月", value: 332351 },
            { type: "六月", value: 335345 },
            { type: "七月", value: 342356 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 335419 },
            { type: "四月", value: 334328 },
            { type: "五月", value: 342356 },
            { type: "六月", value: 342342 },
            { type: "七月", value: 352351 }
          ]
        }
      ]
    },
    {
      type: "爆珠棒",
      color: theme.color["m-brand"],
      ...stickType.burst,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 354412 },
            { type: "四月", value: 364325 },
            { type: "五月", value: 372351 },
            { type: "六月", value: 352345 },
            { type: "七月", value: 362356 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 354419 },
            { type: "四月", value: 344327 },
            { type: "五月", value: 362355 },
            { type: "六月", value: 342343 },
            { type: "七月", value: 362352 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 354412 },
            { type: "四月", value: 346324 },
            { type: "五月", value: 365352 },
            { type: "六月", value: 372345 },
            { type: "七月", value: 342356 }
          ]
        }
      ]
    }
  ]
];

const REPORT_PRODUCTION_SHIFT_QUALIFIEDTREND = [
  [
    {
      type: "四元复合棒",
      color: theme.color.secondary,
      ...stickType.quaternary,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 25624 },
            { type: "四月", value: 31721 },
            { type: "五月", value: 29324 },
            { type: "六月", value: 31345 },
            { type: "七月", value: 35245 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 30722 },
            { type: "四月", value: 46323 },
            { type: "五月", value: 40592 },
            { type: "六月", value: 59241 },
            { type: "七月", value: 53344 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 41591 },
            { type: "四月", value: 31721 },
            { type: "五月", value: 41324 },
            { type: "六月", value: 42345 },
            { type: "七月", value: 45235 }
          ]
        }
      ]
    },
    {
      type: "三元复合棒",
      color: theme.color.cyan,
      ...stickType.ternary,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 39392 },
            { type: "四月", value: 34721 },
            { type: "五月", value: 39324 },
            { type: "六月", value: 45345 },
            { type: "七月", value: 40245 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 35592 },
            { type: "四月", value: 34721 },
            { type: "五月", value: 59324 },
            { type: "六月", value: 61345 },
            { type: "七月", value: 43245 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 42592 },
            { type: "四月", value: 31721 },
            { type: "五月", value: 41324 },
            { type: "六月", value: 55345 },
            { type: "七月", value: 41245 }
          ]
        }
      ]
    },
    {
      type: "二元复合棒",
      color: theme.color.teal,
      ...stickType.duality,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 132368 },
            { type: "四月", value: 103361 },
            { type: "五月", value: 119324 },
            { type: "六月", value: 95452 },
            { type: "七月", value: 96451 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 92368 },
            { type: "四月", value: 112361 },
            { type: "五月", value: 124324 },
            { type: "六月", value: 132452 },
            { type: "七月", value: 112451 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 122361 },
            { type: "四月", value: 102362 },
            { type: "五月", value: 114323 },
            { type: "六月", value: 102454 },
            { type: "七月", value: 112457 }
          ]
        }
      ]
    },
    {
      type: "中空拉丝棒",
      color: theme.color["r-orange"],
      ...stickType.hollow,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 183556 },
            { type: "四月", value: 213545 },
            { type: "五月", value: 203452 },
            { type: "六月", value: 193524 },
            { type: "七月", value: 184552 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 154552 },
            { type: "四月", value: 231546 },
            { type: "五月", value: 212451 },
            { type: "六月", value: 202526 },
            { type: "七月", value: 233551 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 215552 },
            { type: "四月", value: 193546 },
            { type: "五月", value: 153451 },
            { type: "六月", value: 184526 },
            { type: "七月", value: 202551 }
          ]
        }
      ]
    },
    {
      type: "高透棒",
      color: theme.color.purple,
      ...stickType.through,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 294412 },
            { type: "四月", value: 244325 },
            { type: "五月", value: 262351 },
            { type: "六月", value: 312345 },
            { type: "七月", value: 332356 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 284412 },
            { type: "四月", value: 294325 },
            { type: "五月", value: 292351 },
            { type: "六月", value: 315345 },
            { type: "七月", value: 312356 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 305419 },
            { type: "四月", value: 314328 },
            { type: "五月", value: 252356 },
            { type: "六月", value: 292342 },
            { type: "七月", value: 272351 }
          ]
        }
      ]
    },
    {
      type: "爆珠棒",
      color: theme.color["m-brand"],
      ...stickType.burst,
      data: [
        {
          type: "早班",
          color: theme.color.teal,
          ...Shift1,
          data: [
            { type: "三月", value: 314412 },
            { type: "四月", value: 354325 },
            { type: "五月", value: 302351 },
            { type: "六月", value: 292345 },
            { type: "七月", value: 282356 }
          ]
        },
        {
          type: "中班",
          color: theme.color.pink,
          ...Shift2,
          data: [
            { type: "三月", value: 314419 },
            { type: "四月", value: 304327 },
            { type: "五月", value: 312355 },
            { type: "六月", value: 332343 },
            { type: "七月", value: 352352 }
          ]
        },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          ...Shift3,
          data: [
            { type: "三月", value: 294412 },
            { type: "四月", value: 286324 },
            { type: "五月", value: 305352 },
            { type: "六月", value: 302345 },
            { type: "七月", value: 282356 }
          ]
        }
      ]
    }
  ]
];

const REPORT_PRODUCTION_SHIFT_TYPE_TREND = [
  [
    {
      type: "四元复合棒",
      color: theme.color.secondary,
      ...stickType.quaternary,
      data: [
        {
          type: "早班",
          ...Shift1,
          data: [
            { type: "三月", value: 32624 },
            { type: "四月", value: 36721 },
            { type: "五月", value: 34324 },
            { type: "六月", value: 37345 },
            { type: "七月", value: 41245 }
          ]
        },
        {
          type: "中班",
          ...Shift2,
          data: [
            { type: "三月", value: 35722 },
            { type: "四月", value: 48323 },
            { type: "五月", value: 47592 },
            { type: "六月", value: 51241 },
            { type: "七月", value: 58344 }
          ]
        },
        {
          type: "晚班",
          ...Shift3,
          data: [
            { type: "三月", value: 44591 },
            { type: "四月", value: 39721 },
            { type: "五月", value: 43324 },
            { type: "六月", value: 46345 },
            { type: "七月", value: 49235 }
          ]
        }
      ]
    },
    {
      type: "三元复合棒",
      color: theme.color.cyan,
      ...stickType.ternary,
      data: [
        {
          type: "早班",
          ...Shift1,
          data: [
            { type: "三月", value: 42392 },
            { type: "四月", value: 35721 },
            { type: "五月", value: 45324 },
            { type: "六月", value: 51345 },
            { type: "七月", value: 43245 }
          ]
        },
        {
          type: "中班",
          ...Shift2,
          data: [
            { type: "三月", value: 42592 },
            { type: "四月", value: 41721 },
            { type: "五月", value: 56324 },
            { type: "六月", value: 63345 },
            { type: "七月", value: 47245 }
          ]
        },
        {
          type: "晚班",
          ...Shift3,
          data: [
            { type: "三月", value: 46592 },
            { type: "四月", value: 34721 },
            { type: "五月", value: 45324 },
            { type: "六月", value: 57345 },
            { type: "七月", value: 48245 }
          ]
        }
      ]
    },
    {
      type: "二元复合棒",
      color: theme.color.teal,
      ...stickType.duality,
      data: [
        {
          type: "早班",
          ...Shift1,
          data: [
            { type: "三月", value: 162368 },
            { type: "四月", value: 133361 },
            { type: "五月", value: 149324 },
            { type: "六月", value: 125452 },
            { type: "七月", value: 116451 }
          ]
        },
        {
          type: "中班",
          ...Shift2,
          data: [
            { type: "三月", value: 142368 },
            { type: "四月", value: 152361 },
            { type: "五月", value: 184324 },
            { type: "六月", value: 152452 },
            { type: "七月", value: 162451 }
          ]
        },
        {
          type: "晚班",
          ...Shift3,
          data: [
            { type: "三月", value: 152361 },
            { type: "四月", value: 132362 },
            { type: "五月", value: 164323 },
            { type: "六月", value: 122454 },
            { type: "七月", value: 172457 }
          ]
        }
      ]
    },
    {
      type: "中空拉丝棒",
      color: theme.color["r-orange"],
      ...stickType.hollow,
      data: [
        {
          type: "早班",
          ...Shift1,
          data: [
            { type: "三月", value: 233556 },
            { type: "四月", value: 263545 },
            { type: "五月", value: 243452 },
            { type: "六月", value: 223524 },
            { type: "七月", value: 244552 }
          ]
        },
        {
          type: "中班",
          ...Shift2,
          data: [
            { type: "三月", value: 214552 },
            { type: "四月", value: 251546 },
            { type: "五月", value: 242451 },
            { type: "六月", value: 262526 },
            { type: "七月", value: 253551 }
          ]
        },
        {
          type: "晚班",
          ...Shift3,
          data: [
            { type: "三月", value: 245552 },
            { type: "四月", value: 223546 },
            { type: "五月", value: 213451 },
            { type: "六月", value: 244526 },
            { type: "七月", value: 222551 }
          ]
        }
      ]
    },
    {
      type: "高透棒",
      color: theme.color.purple,
      ...stickType.through,
      data: [
        {
          type: "早班",
          ...Shift1,
          data: [
            { type: "三月", value: 314412 },
            { type: "四月", value: 324325 },
            { type: "五月", value: 332351 },
            { type: "六月", value: 352345 },
            { type: "七月", value: 342356 }
          ]
        },
        {
          type: "中班",
          ...Shift2,
          data: [
            { type: "三月", value: 344412 },
            { type: "四月", value: 324325 },
            { type: "五月", value: 332351 },
            { type: "六月", value: 335345 },
            { type: "七月", value: 342356 }
          ]
        },
        {
          type: "晚班",
          ...Shift3,
          data: [
            { type: "三月", value: 335419 },
            { type: "四月", value: 334328 },
            { type: "五月", value: 342356 },
            { type: "六月", value: 342342 },
            { type: "七月", value: 352351 }
          ]
        }
      ]
    },
    {
      type: "爆珠棒",
      color: theme.color["m-brand"],
      ...stickType.burst,
      data: [
        {
          type: "早班",
          ...Shift1,
          data: [
            { type: "三月", value: 354412 },
            { type: "四月", value: 364325 },
            { type: "五月", value: 372351 },
            { type: "六月", value: 352345 },
            { type: "七月", value: 362356 }
          ]
        },
        {
          type: "中班",
          ...Shift2,
          data: [
            { type: "三月", value: 354419 },
            { type: "四月", value: 344327 },
            { type: "五月", value: 362355 },
            { type: "六月", value: 342343 },
            { type: "七月", value: 362352 }
          ]
        },
        {
          type: "晚班",
          ...Shift3,
          data: [
            { type: "三月", value: 354412 },
            { type: "四月", value: 346324 },
            { type: "五月", value: 365352 },
            { type: "六月", value: 372345 },
            { type: "七月", value: 342356 }
          ]
        }
      ]
    }
  ]
];

const REPORT_PRODUCTION_SHIFT_TYPE = [
  [
    {
      type: "四元复合棒",
      color: theme.color.secondary,
      ...stickType.quaternary,
      data: [
        { type: "早班", value: 19245, ...Shift1 },
        { type: "中班", value: 15342, ...Shift2 },
        { type: "晚班", value: 12376, ...Shift3 }
      ]
    },
    {
      type: "三元复合棒",
      color: theme.color.cyan,
      ...stickType.ternary,
      data: [
        { type: "早班", value: 17343, ...Shift1 },
        { type: "中班", value: 15242, ...Shift2 },
        { type: "晚班", value: 13512, ...Shift3 }
      ]
    },
    {
      type: "二元复合棒",
      color: theme.color.teal,
      ...stickType.duality,
      data: [
        { type: "早班", value: 39592, ...Shift1 },
        { type: "中班", value: 33721, ...Shift2 },
        { type: "晚班", value: 35592, ...Shift3 }
      ]
    },
    {
      type: "中空拉丝棒",
      color: theme.color["r-orange"],
      ...stickType.hollow,
      data: [
        { type: "早班", value: 69492, ...Shift1 },
        { type: "中班", value: 73725, ...Shift2 },
        { type: "晚班", value: 75592, ...Shift3 }
      ]
    },
    {
      type: "高透棒",
      color: theme.color.purple,
      ...stickType.through,
      data: [
        { type: "早班", value: 82296, ...Shift1 },
        { type: "中班", value: 83422, ...Shift2 },
        { type: "晚班", value: 85595, ...Shift3 }
      ]
    },
    {
      type: "爆珠棒",
      color: theme.color["m-brand"],
      ...stickType.burst,
      data: [
        { type: "早班", value: 91444, ...Shift1 },
        { type: "中班", value: 94727, ...Shift2 },
        { type: "晚班", value: 92539, ...Shift3 }
      ]
    }
  ]
];

const REPORT_PRODUCTION_SHIFT_RANK = [
  [
    {
      type: "四元复合棒",
      color: theme.color.secondary,
      ...stickType.quaternary,
      data: [
        { type: "早班", color: theme.color.teal, value: 19245, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 15342, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 12376,
          ...Shift3
        }
      ]
    },
    {
      type: "三元复合棒",
      color: theme.color.cyan,
      ...stickType.ternary,
      data: [
        { type: "早班", color: theme.color.teal, value: 17343, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 15242, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 13512,
          ...Shift3
        }
      ]
    },
    {
      type: "二元复合棒",
      color: theme.color.teal,
      ...stickType.duality,
      data: [
        { type: "早班", color: theme.color.teal, value: 39592, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 33721, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 35592,
          ...Shift3
        }
      ]
    },
    {
      type: "中空拉丝棒",
      color: theme.color["r-orange"],
      ...stickType.hollow,
      data: [
        { type: "早班", color: theme.color.teal, value: 69492, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 73725, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 75592,
          ...Shift3
        }
      ]
    },
    {
      type: "高透棒",
      color: theme.color.purple,
      ...stickType.through,
      data: [
        { type: "早班", color: theme.color.teal, value: 82296, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 83422, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 85595,
          ...Shift3
        }
      ]
    },
    {
      type: "爆珠棒",
      color: theme.color["m-brand"],
      ...stickType.burst,
      data: [
        { type: "早班", color: theme.color.teal, value: 91444, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 94727, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 92539,
          ...Shift3
        }
      ]
    }
  ]
];

const REPORT_PRODUCTION_SHIFT_QUALIFIEDRANK = [
  [
    {
      type: "四元复合棒",
      color: theme.color.secondary,
      ...stickType.quaternary,
      data: [
        { type: "早班", color: theme.color.teal, value: 15245, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 13342, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 10376,
          ...Shift3
        }
      ]
    },
    {
      type: "三元复合棒",
      color: theme.color.cyan,
      ...stickType.ternary,
      data: [
        { type: "早班", color: theme.color.teal, value: 15343, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 13242, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 11512,
          ...Shift3
        }
      ]
    },
    {
      type: "二元复合棒",
      color: theme.color.teal,
      ...stickType.duality,
      data: [
        { type: "早班", color: theme.color.teal, value: 35592, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 30721, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 31592,
          ...Shift3
        }
      ]
    },
    {
      type: "中空拉丝棒",
      color: theme.color["r-orange"],
      ...stickType.hollow,
      data: [
        { type: "早班", color: theme.color.teal, value: 61492, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 72725, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 73592,
          ...Shift3
        }
      ]
    },
    {
      type: "高透棒",
      color: theme.color.purple,
      ...stickType.through,
      data: [
        { type: "早班", color: theme.color.teal, value: 79296, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 75422, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 80595,
          ...Shift3
        }
      ]
    },
    {
      type: "爆珠棒",
      color: theme.color["m-brand"],
      ...stickType.burst,
      data: [
        { type: "早班", color: theme.color.teal, value: 90444, ...Shift1 },
        { type: "中班", color: theme.color.pink, value: 90727, ...Shift2 },
        {
          type: "晚班",
          color: theme.color["r-orange"],
          value: 87539,
          ...Shift3
        }
      ]
    }
  ]
];

const REPORT_PRODUCTION_STICKTYPE_QUALIFIEDTREND = [
  [
    {
      type: "四元复合棒",
      color: theme.color.secondary,
      ...stickType.quaternary,
      data: [
        { type: "三月", value: 35592 },
        { type: "四月", value: 33721 },
        { type: "五月", value: 45324 },
        { type: "六月", value: 51345 },
        { type: "七月", value: 41245 }
      ]
    },
    {
      type: "三元复合棒",
      color: theme.color.cyan,
      ...stickType.ternary,
      data: [
        { type: "三月", value: 39592 },
        { type: "四月", value: 41254 },
        { type: "五月", value: 35524 },
        { type: "六月", value: 39234 },
        { type: "七月", value: 40234 }
      ]
    },
    {
      type: "二元复合棒",
      color: theme.color.teal,
      ...stickType.duality,
      data: [
        { type: "三月", value: 112368 },
        { type: "四月", value: 172361 },
        { type: "五月", value: 104324 },
        { type: "六月", value: 112452 },
        { type: "七月", value: 102451 }
      ]
    },
    {
      type: "中空拉丝棒",
      color: theme.color["r-orange"],
      ...stickType.hollow,
      data: [
        { type: "三月", value: 193552 },
        { type: "四月", value: 183546 },
        { type: "五月", value: 243451 },
        { type: "六月", value: 203526 },
        { type: "七月", value: 219551 }
      ]
    },
    {
      type: "高透棒",
      color: theme.color.purple,
      ...stickType.through,
      data: [
        { type: "三月", value: 254144 },
        { type: "四月", value: 205512 },
        { type: "五月", value: 203456 },
        { type: "六月", value: 214256 },
        { type: "七月", value: 282229 }
      ]
    },
    {
      type: "爆珠棒",
      color: theme.color["m-brand"],
      ...stickType.burst,
      data: [
        { type: "三月", value: 294412 },
        { type: "四月", value: 284325 },
        { type: "五月", value: 342351 },
        { type: "六月", value: 302345 },
        { type: "七月", value: 332356 }
      ]
    }
  ]
];

const REPORT_PRODUCTION_STICKTYPE_TREND = [
  [
    {
      type: "四元复合棒",
      color: theme.color.secondary,
      ...stickType.quaternary,
      data: [
        { type: "三月", value: 40592 },
        { type: "四月", value: 35721 },
        { type: "五月", value: 51324 },
        { type: "六月", value: 62345 },
        { type: "七月", value: 45245 }
      ]
    },
    {
      type: "三元复合棒",
      color: theme.color.cyan,
      ...stickType.ternary,
      data: [
        { type: "三月", value: 40592 },
        { type: "四月", value: 43254 },
        { type: "五月", value: 38524 },
        { type: "六月", value: 41234 },
        { type: "七月", value: 48234 }
      ]
    },
    {
      type: "二元复合棒",
      color: theme.color.teal,
      ...stickType.duality,
      data: [
        { type: "三月", value: 162368 },
        { type: "四月", value: 182361 },
        { type: "五月", value: 174324 },
        { type: "六月", value: 152452 },
        { type: "七月", value: 142451 }
      ]
    },
    {
      type: "中空拉丝棒",
      color: theme.color["r-orange"],
      ...stickType.hollow,
      data: [
        { type: "三月", value: 243552 },
        { type: "四月", value: 223546 },
        { type: "五月", value: 253451 },
        { type: "六月", value: 233526 },
        { type: "七月", value: 239551 }
      ]
    },
    {
      type: "高透棒",
      color: theme.color.purple,
      ...stickType.through,
      data: [
        { type: "三月", value: 284144 },
        { type: "四月", value: 245512 },
        { type: "五月", value: 303456 },
        { type: "六月", value: 294256 },
        { type: "七月", value: 292229 }
      ]
    },
    {
      type: "爆珠棒",
      color: theme.color["m-brand"],
      ...stickType.burst,
      data: [
        { type: "三月", value: 324412 },
        { type: "四月", value: 344325 },
        { type: "五月", value: 352351 },
        { type: "六月", value: 332345 },
        { type: "七月", value: 342356 }
      ]
    }
  ]
];

const REPORT_PRODUCTION_STICKTYPE_RANK = [
  [
    {
      type: "四元复合棒",
      value: 40592,
      color: theme.color.secondary,
      ...stickType.quaternary
    },
    {
      type: "三元复合棒",
      value: 40592,
      color: theme.color.cyan,
      ...stickType.ternary
    },
    {
      type: "二元复合棒",
      value: 162368,
      color: theme.color.teal,
      ...stickType.duality
    },
    {
      type: "中空拉丝棒",
      value: 243552,
      color: theme.color["r-orange"],
      ...stickType.hollow
    },
    {
      type: "高透棒",
      value: 284144,
      color: theme.color.purple,
      ...stickType.through
    },
    {
      type: "爆珠棒",
      value: 324412,
      color: theme.color["m-brand"],
      ...stickType.burst
    }
  ]
];

const REPORT_PRODUCTION_STICKTYPE_QUALIFIEDRANK = [
  [
    {
      type: "四元复合棒",
      value: 32592,
      color: theme.color.secondary,
      ...stickType.quaternary
    },
    {
      id: 2,
      type: "三元复合棒",
      value: 36592,
      color: theme.color.cyan,
      ...stickType.ternary
    },
    {
      id: 3,
      type: "二元复合棒",
      value: 122368,
      color: theme.color.teal,
      ...stickType.duality
    },
    {
      id: 4,
      type: "中空拉丝棒",
      value: 133552,
      color: theme.color["r-orange"],
      ...stickType.hollow
    },
    {
      id: 5,
      type: "高透棒",
      value: 234144,
      color: theme.color.purple,
      ...stickType.through
    },
    {
      type: "爆珠棒",
      value: 254412,
      color: theme.color["m-brand"],
      ...stickType.burst
    }
  ]
];

const REPORT_PRODUCTION_STICKTYPE = [
  [
    {
      name: "爆珠棒",
      totalValue: 324412,
      totalRatio: 0.296,
      qualifiedValue: 318721,
      qualifiedValueRatio: 0.316
    },
    {
      name: "高透棒",
      totalValue: 284144,
      totalRatio: 0.259,
      qualifiedValue: 267234,
      qualifiedValueRatio: 0.248
    },
    {
      name: "中空拉丝棒",
      totalValue: 243552,
      totalRatio: 0.222,
      qualifiedValue: 318721,
      qualifiedValueRatio: 0.316
    },
    {
      name: "二元复合棒",
      totalValue: 162368,
      totalRatio: 0.148,
      qualifiedValue: 159249,
      qualifiedValueRatio: 0.139
    },
    {
      name: "三元复合棒",
      totalValue: 40592,
      totalRatio: 0.037,
      qualifiedValue: 392364,
      qualifiedValueRatio: 0.035
    },
    {
      name: "四元复合棒",
      totalValue: 40592,
      totalRatio: 0.037,
      qualifiedValue: 401232,
      qualifiedValueRatio: 0.039
    }
  ]
];

const REPORT_PRODUCTION_OUTPUT = [
  [
    [231, 245, 256, 275, 243, 259, 234],
    [226, 236, 241, 261, 235, 246, 224],
    [0.978, 0.963, 0.941, 0.949, 0.967, 0.949, 0.957]
  ]
];

const REPORT_PRODUCTION_OUTPUT_SLIM = [
  [
    /*        { type: "3月", value: 230, color: theme.color.blue, format: (value, name, index) => { return { name, value: value + "万" } } }, */
    {
      type: "4月",
      value: 245,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "万" };
      }
    },
    {
      type: "5月",
      value: 225,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "万" };
      }
    },
    {
      type: "6月",
      value: 250,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "万" };
      }
    },
    {
      type: "7月",
      value: 265,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "万" };
      }
    }
  ]
];

const REPORT_PRODUCTION_QUALIFIEDRANK_BAR = [
  [
    [4.06, 4.06, 16.24, 24.36, 28.41, 32.44],
    [3.2, 3.6, 12.2, 13.3, 23.4, 25.4],
    [0.978, 0.963, 0.941, 0.949, 0.967, 0.949, 0.957]
  ]
];

const REPORT_PRODUCTION_QUALIFIEDRANK_BAR_SLIM = [
  [
    /*        { type: "3月", value: 230, color: theme.color.blue, format: (value, name, index) => { return { name, value: value + "万" } } }, */
    {
      type: "4月",
      value: 245,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "万" };
      }
    },
    {
      type: "5月",
      value: 225,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "万" };
      }
    },
    {
      type: "6月",
      value: 250,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "万" };
      }
    },
    {
      type: "7月",
      value: 265,
      color: theme.color.blue,
      format: (value, name, index) => {
        return { name, value: value + "万" };
      }
    }
  ]
];

const REPORT_PRODUCTION_SPEED_SLIM = [
  [
    [310, 250, 350, 280, 300],
    [420, 330, 460, 390, 410],
    [0.75, 0.88, 0.83, 0.92, 0.91]
  ],
  [
    [310, 250, 350, 280, 300],
    [420, 330, 460, 390, 410],
    [0.75, 0.88, 0.83, 0.92, 0.91]
  ],
  [
    [310, 250, 350, 280, 300],
    [420, 330, 460, 390, 410],
    [0.75, 0.88, 0.83, 0.92, 0.91]
  ]
];

const REPORT_SCRAP_AMOUNT_SLIM = [
  [
    {
      type: "4月",
      value: 7058,
      color: theme.color.secondary,
      format: (value, name, index) => {
        return { name, value: threePosition(value) };
      }
    },
    {
      type: "5月",
      value: 6875,
      color: theme.color.secondary,
      format: (value, name, index) => {
        return { name, value: threePosition(value) };
      }
    },
    {
      type: "6月",
      value: 5912,
      color: theme.color.secondary,
      format: (value, name, index) => {
        return { name, value: threePosition(value) };
      }
    },
    {
      type: "7月",
      value: 7239,
      color: theme.color.secondary,
      format: (value, name, index) => {
        return { name, value: threePosition(value) };
      }
    }
  ]
];

const REPORT_SCRAP_AMOUNT = [
  [
    [6013, 7145, 6987, 5800, 6590, 7258, 6249],
    [0.0037, 0.0051, 0.0078, 0.0048, 0.0067, 0.0079, 0.0059]
  ]
];

const REPORT_PRODUCTION_STICK_OUTPUT = [
  [
    [89, 67, 74, 69, 83, 85, 81],
    [81, 61, 70, 61, 76, 76, 77],
    [0.971, 0.975, 0.958, 0.955, 0.984, 0.961, 0.969]
  ],
  [
    [67, 69, 74, 82, 76, 81, 75],
    [59, 61, 67, 77, 69, 76, 70],
    [0.951, 0.971, 0.973, 0.981, 0.961, 0.968, 0.956]
  ],
  [
    [59, 65, 67, 78, 71, 82, 77],
    [49, 61, 62, 69, 62, 76, 69],
    [0.955, 0.973, 0.946, 0.952, 0.971, 0.946, 0.957]
  ],
  [
    [69, 75, 71, 65, 68, 74, 76],
    [59, 71, 64, 61, 62, 67, 68],
    [0.955, 0.975, 0.955, 0.948, 0.972, 0.959, 0.942]
  ]
];
